export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[640px] flex items-center bg-background-100 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/40 via-background-50/60 to-accent-100/30"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-shield-check-line text-sm"></i>
              <span>官方入口 · 安全访问</span>
              <span className="w-1 h-1 rounded-full bg-primary-400"></span>
              <span>每日更新</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight mb-4 text-foreground-950">
              贝勒漫画
              <span className="block text-2xl md:text-3xl lg:text-3xl text-foreground-700 mt-1">
                韩漫日漫国漫在线阅读平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading mb-5">
              —— 热门漫画一网打尽，畅享阅读乐趣
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              贝勒漫画网作为贝勒漫画官方入口，聚合海量韩漫、日漫、国漫热门资源，
              提供最新网址导航与流畅在线观看体验。每日同步更新热门连载，
              覆盖恋爱、奇幻、动作、悬疑等多元题材，是漫画爱好者的一站式阅读乐园。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500">2000+</div>
                <div className="text-xs text-foreground-500 mt-1">部热门漫画</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">稳定同步连载</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500">多端适配</div>
                <div className="text-xs text-foreground-500 mt-1">网页 · APP · 平板</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line text-lg"></i>
                下载贝勒漫画APP
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-primary-300 text-primary-700 font-medium text-sm hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                浏览专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative w-full aspect-[5/4] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20digital%20illustration%20of%20a%20cozy%20comic%20reading%20scene%2C%20a%20young%20person%20sitting%20comfortably%20on%20a%20couch%20reading%20manga%20on%20a%20tablet%2C%20surrounded%20by%20floating%20colorful%20comic%20panels%20and%20speech%20bubbles%20showing%20various%20manga%20scenes%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20soft%20golden%20lighting%20from%20a%20nearby%20window%2C%20modern%20anime%20art%20style%20with%20clean%20lines%2C%20comfortable%20and%20inviting%20atmosphere%20with%20bookshelves%20and%20plants%20in%20the%20background%2C%20editorial%20quality%20digital%20art&width=1040&height=832&seq=hero-beile-comics&orientation=landscape"
                alt="贝勒漫画在线阅读场景插画"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}